import React from "react";
import ArchiveNav from "./ArchiveNav";
const MobileFilters = (props) => {
  const {
    setActiveFilter,
    setFilterOrder,
    archiveView,
    setArchiveView,
    mobileFiltersOpen,
    setMobileFiltersOpen,
  } = props;

  return (
    <div
      className={`archive__mobile-filters-wrapper ${
        mobileFiltersOpen ? "active" : ""
      }`}
    >
      <button
        className="ra__button archive__filters-close"
        onClick={() => {
          setMobileFiltersOpen(false);
        }}
      >
        <span className="ra__arrow">&times;</span>
      </button>

      <div className="archive__mobile-filters-inner">
        <ArchiveNav
          {...{
            archiveView,
            setArchiveView,
            setMobileFiltersOpen,
          }}
        />

        <div className="archive__filter-title">Mix Number:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("mixNumber");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`High > Low`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("mixNumber");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`Low > High`}</button>
        </div>

        <div className="archive__filter-title">Artist(s):</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("title");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`A > Z`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("title");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Z > A`}</button>
        </div>

        <div className="archive__filter-title">Duration:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("duration");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`Shortest > Longest`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("duration");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Longest > Longest`}</button>
        </div>

        <div className="archive__filter-title">Listens:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("plays");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Most > Least`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("plays");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`Least > Most`}</button>
        </div>

        {/* <div className="archive__filter-title">Genre:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("genre");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`A > Z`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("genre");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Z > A`}</button>
        </div> */}

        <div className="archive__filter-title">Likes:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("favs");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Most > Least`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("favs");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`Least > Most`}</button>
        </div>

        <div className="archive__filter-title">Release Date:</div>
        <div className="archive__filter-buttons-wrapper">
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("releaseDate");
              setFilterOrder("desc");
              setMobileFiltersOpen(false);
            }}
          >{`Newest > Oldest`}</button>
          <button
            className="ra__button archive__mobile-filter-button"
            onClick={() => {
              setActiveFilter("releaseDate");
              setFilterOrder("asc");
              setMobileFiltersOpen(false);
            }}
          >{`Oldest > Newest`}</button>
        </div>
      </div>
    </div>
  );
};

export default MobileFilters;
